import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Press.css';

const Press = () => {
  return (
    <div className="press-page">
      <Helmet>
        <title>Prensa | Graphyra</title>
        <meta name="description" content="Información de prensa y contacto para medios sobre Graphyra" />
      </Helmet>

      <div className="press-container">
        <section className="press-hero">
          <h1 className="press-title">Sala de Prensa</h1>
          <p className="press-subtitle">
            Recursos e información para medios de comunicación
          </p>
        </section>

        <section className="press-content">
          <div className="content-card">
            <div className="icon-large">📰</div>
            <h2>Sobre Graphyra</h2>
            <p className="lead-text">
              <strong>Graphyra</strong> es una plataforma digital innovadora que democratiza el acceso 
              al conocimiento, conectando personas con contenido educativo, científico y cultural de calidad.
            </p>
            <p>
              Fundada en 2026 por Luis Cepeda, Graphyra combina artículos científicos, recursos educativos, 
              videos, cursos y entretenimiento inteligente en un solo ecosistema digital. Nuestra misión es 
              hacer que el conocimiento sea accesible, comprensible y disfrutable para todos.
            </p>
          </div>

          <div className="content-card">
            <h2>Datos Clave</h2>
            <div className="key-facts">
              <div className="fact-item">
                <div className="fact-label">Fundación</div>
                <div className="fact-value">2026</div>
              </div>
              <div className="fact-item">
                <div className="fact-label">Fundador y CEO</div>
                <div className="fact-value">Luis Cepeda</div>
              </div>
              <div className="fact-item">
                <div className="fact-label">Categorías</div>
                <div className="fact-value">Ciencia, Tecnología, Cultura, Educación</div>
              </div>
              <div className="fact-item">
                <div className="fact-label">Plataformas</div>
                <div className="fact-value">Web (Desktop & Mobile)</div>
              </div>
            </div>
          </div>

          <div className="content-card">
            <h2>Áreas de Contenido</h2>
            <div className="content-areas">
              <div className="area-item">
                <h3>📚 Academy</h3>
                <p>Cursos y recursos educativos sobre tecnología, programación y desarrollo de habilidades</p>
              </div>
              <div className="area-item">
                <h3>📰 Magazine</h3>
                <p>Artículos científicos, ensayos y reportajes de calidad sobre temas diversos</p>
              </div>
              <div className="area-item">
                <h3>📺 TV</h3>
                <p>Contenido audiovisual educativo, documentales y series temáticas</p>
              </div>
              <div className="area-item">
                <h3>🎮 Games</h3>
                <p>Juegos educativos que combinan aprendizaje con entretenimiento</p>
              </div>
            </div>
          </div>

          <div className="content-card highlight-card">
            <div className="icon-large">📧</div>
            <h2>Contacto de Prensa</h2>
            <p>
              Para consultas de medios, entrevistas, colaboraciones o más información:
            </p>
            <div className="press-contacts">
              <div className="contact-method">
                <h4>Email Principal</h4>
                <a href="mailto:contact.graphyra@gmail.com" className="contact-link">
                  contact.graphyra@gmail.com
                </a>
              </div>
              <div className="contact-method">
                <h4>Email Administrativo</h4>
                <a href="mailto:admin.graphyra@gmail.com" className="contact-link">
                  admin.graphyra@gmail.com
                </a>
              </div>
              <div className="contact-method">
                <h4>Teléfono</h4>
                <a href="tel:+573115491733" className="contact-link">
                  +57 3115491733
                </a>
              </div>
            </div>
            <p className="response-note">
              <strong>Tiempo de respuesta:</strong> Nos esforzamos por responder a todas las consultas 
              de prensa dentro de 24-48 horas hábiles.
            </p>
          </div>

          <div className="content-card">
            <h2>Kit de Prensa</h2>
            <p>
              Actualmente estamos preparando nuestro kit de prensa oficial que incluirá:
            </p>
            <ul className="press-kit-list">
              <li>Logos de Graphyra en diferentes formatos y colores</li>
              <li>Capturas de pantalla de la plataforma</li>
              <li>Biografía oficial del fundador</li>
              <li>Hechos y cifras actualizadas</li>
              <li>Comunicados de prensa recientes</li>
            </ul>
            <p className="kit-note">
              Mientras preparamos estos recursos, por favor contáctanos directamente para solicitar 
              materiales específicos.
            </p>
          </div>

          <div className="content-card">
            <h2>Cobertura de Medios</h2>
            <p>
              A medida que crezcamos, esta sección incluirá menciones de Graphyra en medios de comunicación, 
              entrevistas y artículos destacados.
            </p>
            <p className="coverage-note">
              ¿Tu medio cubrió a Graphyra? <a href="mailto:contact.graphyra@gmail.com">Háznoslo saber</a> 
              {' '}para incluirlo aquí.
            </p>
          </div>
        </section>

        <section className="press-footer">
          <h3>¿Necesitas Más Información?</h3>
          <p>
            Estamos abiertos a conversaciones con medios, colaboraciones y oportunidades de difusión. 
            No dudes en contactarnos.
          </p>
          <div className="footer-actions">
            <Link to="/about" className="footer-button">Acerca de Graphyra</Link>
            <Link to="/contact" className="footer-button secondary">Formulario de Contacto</Link>
          </div>
        </section>

        <div className="page-footer">
          <div className="footer-links">
            <Link to="/about">Acerca de</Link>
            <span className="separator">•</span>
            <Link to="/careers">Trabaja con Nosotros</Link>
            <span className="separator">•</span>
            <Link to="/">Volver al inicio</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Press;
